import { render, staticRenderFns } from "./videoShow.vue?vue&type=template&id=9dc0aff6&"
import script from "./videoShow.vue?vue&type=script&lang=js&"
export * from "./videoShow.vue?vue&type=script&lang=js&"
import style0 from "./videoShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports